var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "boss-create-new-scout-container",
      attrs: { id: "message-register" },
    },
    [
      _c(
        "h2",
        {
          staticClass: "boss-new-scout-title",
          attrs: { "data-test": "scout-title" },
        },
        [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
      ),
      _vm._v(" "),
      _c("scout-create-target-members", {
        attrs: { "is-edit": _vm.isEdit, members: _vm.members },
        on: { setUserChecked: _vm.setUserChecked },
      }),
      _vm._v(" "),
      _vm.isEdit
        ? [
            _c("scout-create-message", {
              attrs: {
                message: _vm.message,
                "send-date": _vm.reservation.sendDate,
                "send-time": _vm.reservation.sendTime,
                "reservation-name": _vm.reservation.name,
                "is-immediately": _vm.isImmediately,
                "checked-user-ids": _vm.checkedUserIds,
                "scout-end-date": _vm.scoutEndDate,
                "reservation-id": Number(_vm.$route.params.reservationId),
                "is-scouted-for-transition": _vm.isScoutedForTransition,
              },
              on: {
                "update:message": function ($event) {
                  _vm.message = $event
                },
                "update:sendDate": function ($event) {
                  return _vm.$set(_vm.reservation, "sendDate", $event)
                },
                "update:send-date": function ($event) {
                  return _vm.$set(_vm.reservation, "sendDate", $event)
                },
                "update:sendTime": function ($event) {
                  return _vm.$set(_vm.reservation, "sendTime", $event)
                },
                "update:send-time": function ($event) {
                  return _vm.$set(_vm.reservation, "sendTime", $event)
                },
                "update:reservationName": function ($event) {
                  return _vm.$set(_vm.reservation, "name", $event)
                },
                "update:reservation-name": function ($event) {
                  return _vm.$set(_vm.reservation, "name", $event)
                },
                "update:isImmediately": function ($event) {
                  _vm.isImmediately = $event
                },
                "update:is-immediately": function ($event) {
                  _vm.isImmediately = $event
                },
                "show-detail": _vm.showDetail,
              },
            }),
          ]
        : [
            _c("scout-create-message-detail", {
              attrs: {
                subject: _vm.message.subject,
                body: _vm.message.body,
                "is-scout-send-disabled": _vm.isScoutSendDisabled,
                "special-favor-ids": _vm.message.specialFavorIds,
                "reservation-date": _vm.reservationDate,
                "reservation-name": _vm.reservation.name,
              },
              on: {
                "switching-state": _vm.switchingState,
                "register-scout-messages": _vm.registerScoutMessages,
              },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }